import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import "./AboutStats.css";

const AboutStats = () => {
  const statsRef = useRef(null);

  const [stats, setStats] = useState(null);
  const [animated, setAnimated] = useState([0, 0, 0]);
  const [hasAnimated, setHasAnimated] = useState(false);

  /* ===== FETCH STATS ===== */
  useEffect(() => {
    fetch("https://siteapi.flytutor.in/api/stats")
      .then((res) => res.json())
      .then((data) => {
        setStats(data);
        setAnimated([0, 0, 0]);
        setHasAnimated(false);
      })
      .catch((err) =>
        console.error("Stats Fetch Error:", err)
      );
  }, []);

  /* ===== COUNT UP ===== */
  const animateCount = useCallback(() => {
    const duration = 1400;
    const start = performance.now();

    const animate = (time) => {
      const progress = Math.min(
        (time - start) / duration,
        1
      );

      setAnimated([
        Math.floor(progress * (stats?.students || 0)),
        Math.floor(progress * (stats?.courses || 0)),
        Math.floor(progress * (stats?.certificates || 0)),
      ]);

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [stats]);

  /* ===== OBSERVER ===== */
  useEffect(() => {
    if (!stats) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          animateCount();
          setHasAnimated(true);
        }
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, [stats, hasAnimated, animateCount]);

  return (
    <section
      className="about-stats-section"
      ref={statsRef}
    >
      <div className="about-stats-container">
        <div className="about-stat-item">
          <div className="about-stat-number">
            {animated[0]}+
          </div>
          <div className="about-stat-label">
            Students Trained
          </div>
        </div>

        <div className="about-stat-item">
          <div className="about-stat-number">
            {animated[1]}+
          </div>
          <div className="about-stat-label">
            Courses
          </div>
        </div>

        <div className="about-stat-item">
          <div className="about-stat-number">
            {animated[2]}+
          </div>
          <div className="about-stat-label">
            Certificates Issued
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStats;
